import React from "react";
import Nodata from "../../shared-components/no-data-svg/no-data-svg";
import { FormattedMessage } from "react-intl";
import RoutesConstants from "../../constants/routes.constant";
import { useHistory } from "react-router-dom";

const PageNotFound = () => {
  const history = useHistory();
  const goBackToStoreLogin = () => {
    history.push(RoutesConstants.StoreLogin);
  };
  const goBackToCustomerLogin = () => {
    history.push(RoutesConstants.CustomerLogin);
  };
  return (
    <>
      <div
        className="text-center d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Nodata />
        <h1>
          <FormattedMessage id="page_not_found" />
        </h1>
        <div className="text-center">
          {/* <p className="text-muted text-sm mb-0 mt-3"><FormattedMessage id="page_not_found_description" /></p> */}
          <div className="mt-3 d-flex justify-content-center gap-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                goBackToStoreLogin();
              }}
            >
              <FormattedMessage id="GoToStoreLogin" />
            </button>
            <button
              className="btn btn-primary"
              onClick={goBackToCustomerLogin}
            >
              <FormattedMessage id="GoToCustomerLogin" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// export default injectIntl(PageNotFound);
export default PageNotFound;
